// extracted by mini-css-extract-plugin
module.exports = {"popout":"Edit_popout__dTtqZ","title":"Edit_title__wQNEN","footer":"Edit_footer__q_7oy","form":"Edit_form__T_e46","message":"Edit_message__aojnt"};